module.exports = __webpack_public_path__ + "img/switzerland-liver-cancer-female.11af1160.png";